"use strict";
const $khttp = require('./khttp');
const $kutil = require('./kutil');
const $kspace = require('./kspace');
;(function (root, factory) {
	if (typeof exports === "object") {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.$MobileApi = factory(root.$MobileApi);
	}
}(this, function ( extent ){

	/**
	 * API OP参数常量
	 * @type {Object}
	 */
	const _ = {
		_ROOTID: 0,
		_IndexApi: "/apps/pan/index/api",
	};


	const MobileApi = buildObj({

	}, extent?extent:{});
	

	/**
	 * 获取系统的TOP10的热门文件
	 * /apps/pan/index/api?op=querytopoperation
	[
		{
			sum:10,
			filepath:"",
			viewcount:127
		}
	]
	 */
	MobileApi.queryTopOperation = function( dirpath, uid, topn, minsum ){
		return $khttp.post(_._IndexApi, {
			op: "querytopoperation",
			dirpath: dirpath,
			uid: uid?uid:"",
			topn: topn,
			minsum: minsum,
		});
	};
	MobileApi.myRecentFiles = function( topn ){
		return $khttp.get(_._IndexApi, {
			op: "myrecentfiles",
			topn: topn,
		});
	};

	MobileApi.tenantDochotFiles = function( dirpath, types, topn ){
		return $khttp.get(_._IndexApi, {
			op: "tenantdochotfiles",
			dirpath: dirpath,
			types: types?JSON.stringify(types):'',
			topn: topn,
		});
	};
	/**
	 * 根据一组文件获取一组推荐文件（相似度）
	 * /apps/pan/index/api?op=suggestdocuments
	[{
		filepath: xxxx,
		simhash: [spacenode1, ...spacenode2],
		tag: [spacenode1, ...spacenode2]
	}]
	 */
	MobileApi.listSuggestDocuments = function( filepaths, suggestcount ){
		return $khttp.post(_._IndexApi, {
			op: "suggestdocuments",
			filepaths: JSON.stringify(filepaths),
			suggestcount: suggestcount?suggestcount:10,
		});
	};

	/**
	 * 创建分享链接
	 * @param  {[type]} filepaths  [ ]
	 * @param  {[type]} operation  [preview,download]
	 * @param  {[type]} password   [ ]
	 * @param  {[type]} expiretype [0,7,30]
	 * @return {[type]}            [ ]
	 */
	MobileApi.createlink = function(filepaths, operation, password, expiretype, maxaccesscount, linksource){
		return $khttp.post("/api/pan/share",{"op":"createlink","filepaths":JSON.stringify(filepaths),"operations":operation.join(","),"password":password,"expiretype":expiretype,"maxaccesscount":maxaccesscount, "linksource":linksource});
	};
	
	/**
	 * 分享文件给同事
	 * @param  {[type]} filepaths  [ ]
	 * @param  {[type]} shareusers [ ]
	 * @param  {[type]} operation  [preview,download]
	 * @param  {[type]} password   [ ]
	 * @param  {[type]} expiretype [0,7,30]
	 * @param  {[type]} comment    [ ]
	 * @return {[type]}            [ ]
	 */
	MobileApi.sendusers = function( filepaths, shareusers, operation, password, expiretype, comment ){
		return $khttp.post("/api/pan/share",{"op":"sendusers","filepaths":JSON.stringify(filepaths),"uids":JSON.stringify(shareusers),"operations":operation.join(","),"password":password,"expiretype":expiretype,comment:comment});
	};
	// 删除链接
	MobileApi.removeshares = function( shareids ){
		return $khttp.post("/api/pan/share",{"op":"removeshares","shareids":JSON.stringify(shareids)});
	};
	// 获取路径上次链接
	MobileApi.getpathlinks = function( filepaths ){
		return $khttp.post("/api/pan/share",{"op":"getpathlinks","filepaths":JSON.stringify(filepaths)});
	};
	// copy as --- $kspace.js ------------------------------------------------------------------------
	// 删除
	MobileApi.deletes = function(paths){
		if( paths.length > 1 ){
			var map = {};
			for (var i = 0; i < paths.length; i++) {
				var apiserver = $kutil.getspaceapiurl( paths[i] );
				if( map[apiserver.toString( )] ){
					map[apiserver.toString( )].push( paths[i] );
				}else{
					map[apiserver.toString( )] = [ paths[i] ];
				}
			}
			return new Promise(function(resolve, reject){
				for(var key in map ){
					var res = $khttp.postSync(apiserver,{"op":"dodeletes", "paths":$kspace.list2json( map[ key.toString( ) ] )});
					// console.log( res )
				}
				resolve( );
			});
		}else{
			var apiserver = $kutil.getspaceapiurl(paths[0]);
			return $khttp.post(apiserver,{"op":"dodeletes","paths":$kspace.list2json(paths)});
		}
	};
	// copy as --- $kspace.js -------------------------------------------------------------------- end ----
	
	/**
	 * 工具函数
	 */
	buildObj(MobileApi, {
		// 判断是否是 XX 类型
		isType: function( obj, type ){
			try{
				var testType = Object.prototype.toString.call(obj).slice(8,-1).toLowerCase( );
				return (testType === type.toLowerCase( )); 
			}catch( e ){
				return false;
			}
		},
		/**
		 * 拓展|覆盖对象属性 
		 * B_IsCopy 指定是否使用拷贝的方式给原有对象添加属性, 默认使用拷贝方式
		*/ 
		extendAttrs: function( OB_Src, OB_Add, B_IsCopy ){
			if( !OB_Src ){
				return OB_Add;
			}
			if(!MobileApi.isType( OB_Src, "object" )){
				OB_Src = {};
			}
			for( var Tx_Key in OB_Add){
				if(MobileApi.isType( OB_Add[ Tx_Key ], "object" ) && B_IsCopy !== false ){
					OB_Src[ Tx_Key ] = MobileApi.extendAttrs(OB_Src[Tx_Key], OB_Add[ Tx_Key ]);
				}else{
					OB_Src[Tx_Key] = OB_Add[ Tx_Key ];
				}
			} 
			return OB_Src; 
		},
	});

	/**
	 * 参数非空验证
	 * @return {[type]} [description]
	 */
	function argsValidateEmpty( ){
		var _args = arguments;
		return new Promise(function(resolve, reject){
			// console.log("_args: ", _args)
			try{
				// 包含验证参数和一个回掉函数
				if( !_args || _args.length < 2 ){
					throw new Error("API参数错误, 请检查接口参数");
				}
				for (var i = 0; i < _args.length-1; i++) {
					if( _args[i] == undefined || _args[i] == "" ){
						throw new Error("API参数错误, 请检查接口参数");
					}
				}
				_args[_args.length-1]( ).then(resolve).catch(reject);
			}catch( err ){
				reject( err );
			}
		});
	};

	/**
	 * 拓展Object属性
	 * @param  {[type]} obj    [description]
	 * @param  {[type]} addObj [description]
	 * @return {[type]}        [description]
	 */
	function buildObj( obj, addObj ){
		if( !obj ){
			obj = {};
		}
		if( !addObj ){
			return obj;
		}
		for(var key in addObj ){
			if( addObj[key] == undefined ){
				continue;
			}
			if( null == addObj[key] ){
				addObj[key] = "";
			}
			obj[key] = addObj[key];
		}
		return obj;
	};

	// console.log( "MobileApi", MobileApi);
	return MobileApi;
}));

